import { InlineDisplayContent, TextInput } from '@ztechapps/webui.input'
import React from 'react'
import { useCheckoutContext } from '../../index'

export const PoNumber = () => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions

  return (
    <InlineDisplayContent
      label="Your Purchase Order Number"
      help=" Optionally, you can set here your Purchase Order Number. We will show this value on shipping label so you can easily determine that it is authentic shipment from us."
    >
      <TextInput
        placeholder="Your PO# (e.g. ORD-10923432)"
        maxLength={35}
        value={shippingOptions?.customerPoNumber}
        onChange={(e) => {
          setShippingOptions({ customerPoNumber: e?.target.value })
        }}
      />
    </InlineDisplayContent>
  )
}
